import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { FOLDER_CONTENTS_DISPLAYING_SETTINGS } from '@tarslib/types/lib/httpFolder';
import { FoxIconFlipBackward } from 'aui-biz-icons';
import clsx from 'clsx';
import React from 'react';
import { SidebarFolder } from '../sidebar-folder/SidebarFolder';

export type RootBackFoldersProps = {
  className?: string;
};

export function RootBackFolders(props: RootBackFoldersProps) {
  const { className } = props;

  const goBackSidebarTreeApiFolderNode = useDocsDataModelStore(
    (x) => x.sidebarTree.goBackSidebarTreeApiFolderNode,
  );
  const rootSidebarTreeApiFolderNode = useDocsDataModelStore(
    (x) => x.sidebarTree.rootSidebarTreeApiFolderNode,
  );

  const isParentSidebarTreeApiFolderHide = React.useMemo(() => {
    return (
      rootSidebarTreeApiFolderNode?.shareSettings.folderContentsDisplayingSettings ===
      FOLDER_CONTENTS_DISPLAYING_SETTINGS.HIDE
    );
  }, [rootSidebarTreeApiFolderNode]);

  if (!rootSidebarTreeApiFolderNode) {
    return null;
  }
  return (
    <div className={clsx(className)}>
      <ul>
        {goBackSidebarTreeApiFolderNode && (
          <SidebarFolder
            indentation={0}
            index={0}
            value={goBackSidebarTreeApiFolderNode}
            prefixIcon={<FoxIconFlipBackward size={16} />}
            className="mb-2 items-center text-secondary"
            isHidden={false}
          />
        )}

        <SidebarFolder
          indentation={0}
          index={0}
          value={rootSidebarTreeApiFolderNode}
          className={clsx('text-lg text-color', {
            ['!cursor-default hover:bg-transparent']: isParentSidebarTreeApiFolderHide,
          })}
          noLink={isParentSidebarTreeApiFolderHide}
          isHidden={false}
        />
      </ul>
      <div className="my-3 ml-3 h-[1px] w-[calc(100%-24px)] border-b border-color-split" />
    </div>
  );
}
